import { dealDamage, healDamage, addModifier } from '../player.type';
import type { Die } from '../die.type';
import type { Technique } from '../techniques.type';
import type { Player } from '../player.type';
import type { Infusion } from '../status-effects/infusion';
import { DieFace } from '../face.type';
import { StatusEffect } from '../status-effects.type';
import { SoundType } from '../../components/audio.svelte';
import { ModifierTags } from '../modifier.type';

export const fire: Technique[] = [
  {
    ingredients: [DieFace.Fire],
    requirements: [
      {
        text: 'No Infusion other than fire',
        iconBonus: 'no',
        icon: 'infusion',
        test: (source: Player, target: Player) => {
          const infusion = source.statusEffects.find((modifier) => {
            let mod = modifier as Infusion;
            return mod.type == StatusEffect.Infusion && mod.infusion != DieFace.Fire;
          });
          return !infusion;
        },
      },
    ],
    title: 'Elemental Infusion (fire)',
    text: 'Gain 1 Infusion (fire).',
    tags: ['buff'],
    audio: SoundType.None,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      addModifier(source, StatusEffect.Infusion, 1, { infusion: DieFace.Fire });
    },
  },
  {
    ingredients: [DieFace.Fire, DieFace.Mana],
    title: 'Flame Strike',
    text: 'Deal 1 damage, Apply 2 Burning.',
    tags: ['damage', 'debuff'],
    audio: SoundType.AttackFire,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      dealDamage({ value: 1, target, source, dice });
      addModifier(target, StatusEffect.Burning, 2);
    },
  },
  {
    ingredients: [DieFace.Fire, DieFace.Fire],
    title: 'Unstable Fireball',
    text: 'Deal 3 damage, Apply 3 Burning. Take 1 damage, Gain 2 Burning.',
    tags: ['damage', 'debuff', 'suffer'],
    audio: SoundType.AttackFire,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      dealDamage({ value: 3, target, source, dice });
      addModifier(target, StatusEffect.Burning, 3);

      dealDamage({ value: 1, target: source, source, dice });
      addModifier(source, StatusEffect.Burning, 2);
    },
  },
  {
    ingredients: [DieFace.Fire, DieFace.Fire, DieFace.Mana],
    title: 'Focused Fireball',
    text: 'Deal 3 damage, Apply 3 Burn and Purge 1.',
    tags: ['damage', 'debuff'],
    audio: SoundType.AttackFire,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      dealDamage({ value: 3, target, source, dice });
      addModifier(target, StatusEffect.Burning, 3);

      const boon = target.statusEffects.find((modifier) => {
        return modifier.tags.includes(ModifierTags.Boon);
      });

      if (boon) {
        boon.removeStacks(boon.stacks);
      }
    },
  },
  {
    ingredients: [DieFace.Fire, DieFace.Blood],
    title: 'Causterise Wound',
    text: 'If Bleeding heal for bleeding stacks, remove Bleeding. Otherwise heal 2.',
    tags: ['heal'],
    audio: SoundType.MagicFire,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      const bleeding = source.statusEffects.find((modifier) => {
        return modifier.type == StatusEffect.Bleed;
      });

      if (bleeding) {
        const stacks = bleeding.stacks;
        bleeding.removeStacks(stacks);
        healDamage({ value: stacks, target: source, source, dice });
      } else {
        healDamage({ value: 2, target: source, source, dice });
      }
    },
  },
  {
    ingredients: [DieFace.Fire, DieFace.Brain],
    title: 'Cleansing Fire',
    text: 'Cleanse 1 Self.',
    tags: ['cleanse'],
    audio: SoundType.MagicFire,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      const bane = source.statusEffects.find((modifier) => {
        return modifier.tags.includes(ModifierTags.Bane);
      });

      if (bane) {
        bane.removeStacks(bane.stacks);
      }
    },
  },
  {
    ingredients: [DieFace.Fire, DieFace.Fist],
    title: 'Fire Punch',
    text: 'Deal 2 damage, Apply 1 Burning and 1 Clumsy.',
    tags: ['damage', 'debuff'],
    audio: SoundType.AttackFire,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      dealDamage({ value: 2, target, source, dice });
      addModifier(target, StatusEffect.Burning, 1);
      addModifier(target, StatusEffect.Clumsy, 1);
    },
  },
  /* {
    ingredients: [DieFace.Fire, DieFace.Blood],
    title: 'Causterise Wound',
    text: 'If Bleeding heal for bleeding stacks, remove Bleeding. Else heal 2.',
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      const bleeding = source.modifiers.find(modifier => {
        return modifier.type == 'bleeding'
      });

      if (bleeding) {
        const stacks = bleeding.stacks;
        bleeding.removeStacks(stacks);
        healDamage({ value: stacks, target: source, source });
      }
      else {
        healDamage({ value: 2, target: source, source });
      }
    }
  }, */
];
